import '../../../../assets/css/screens/customer/dashboard/hireprofessionals/HireProfessionals.css';
import AppNavbar from '../../../../components/customer/dashboard/apphome/appnavbar/AppNavbar';

import React, { useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  ArrowLeft, Search, SlidersHorizontal, CheckCircle,
  Star, MapPin, Zap, Wrench, Sparkles, Paintbrush,
  UtensilsCrossed, Wind, Truck, X
} from 'lucide-react';

/* ── Workers data with profile images ── */
const WORKERS = [
  { 
    id: 1, 
    name: 'Ahmed Khan', 
    service: 'Electrical', 
    rate: 'Rs 3,500', 
    rating: 4.8, 
    reviews: 124, 
    location: 'Satellite Town, Gujranwala', 
    verified: true,
    profileImage: 'https://ui-avatars.com/api/?name=Ahmed+Khan&background=ffc107&color=fff&size=128',
    color: '#fff3cd', 
    iconBg: '#ffc107', 
    Icon: Zap 
  },
  { 
    id: 2, 
    name: 'Sarah Miller', 
    service: 'Cleaning', 
    rate: 'Rs 2,800', 
    rating: 4.9, 
    reviews: 89, 
    location: 'Wapda Town, Gujranwala', 
    verified: true,
    profileImage: 'https://ui-avatars.com/api/?name=Sarah+Miller&background=28a745&color=fff&size=128',
    color: '#d4edda', 
    iconBg: '#28a745', 
    Icon: Sparkles 
  },
  { 
    id: 3, 
    name: 'Ahmed Khan', 
    service: 'Plumbing', 
    rate: 'Rs 4,000', 
    rating: 4.7, 
    reviews: 156, 
    location: 'Bahar Colony, Gujranwala', 
    verified: true,
    profileImage: 'https://ui-avatars.com/api/?name=John+Smith&background=17a2b8&color=fff&size=128',
    color: '#d1ecf1', 
    iconBg: '#17a2b8', 
    Icon: Wrench 
  },
  { 
    id: 4, 
    name: 'Maria Garcia', 
    service: 'Cooking', 
    rate: 'Rs 4,500', 
    rating: 4.6, 
    reviews: 67, 
    location: 'City Center, Gujranwala', 
    verified: true,
    profileImage: 'https://ui-avatars.com/api/?name=Maria+Garcia&background=fd7e14&color=fff&size=128',
    color: '#ffe5d0', 
    iconBg: '#fd7e14', 
    Icon: UtensilsCrossed 
  },
  { 
    id: 5, 
    name: 'David Wilson', 
    service: 'Painting', 
    rate: 'Rs 5,500', 
    rating: 4.8, 
    reviews: 203, 
    location: 'Gulshanabad, Gujranwala', 
    verified: true,
    profileImage: 'https://ui-avatars.com/api/?name=David+Wilson&background=6f42c1&color=fff&size=128',
    color: '#e8d5f5', 
    iconBg: '#6f42c1', 
    Icon: Paintbrush 
  },
  { 
    id: 6, 
    name: 'Ali Hassan', 
    service: 'Ac Service', 
    rate: 'Rs 5,000', 
    rating: 4.5, 
    reviews: 45, 
    location: 'Mughalpura, Gujranwala', 
    verified: true,
    profileImage: 'https://ui-avatars.com/api/?name=Ali+Hassan&background=0491e1&color=fff&size=128',
    color: '#cce5ff', 
    iconBg: '#0491e1', 
    Icon: Wind 
  },
];

const SERVICES = ['All','Electrical','Plumbing','Cleaning','Painting','Cooking','Ac Service','Shifting'];
const LOCATIONS = [
  'All Locations',   // Capital L
  'Satellite Town', 
  'Wapda Town', 
  'Bahar Colony', 
  'City Center', 
  'Gulshanabad', 
  'Mughalpura'
];


const SERVICE_ICONS = {
  Electrical: Zap, Plumbing: Wrench, Cleaning: Sparkles,
  Painting: Paintbrush, Cooking: UtensilsCrossed, 'Ac Service': Wind, Shifting: Truck,
};

const AllWorkers = () => {
  const navigate          = useNavigate();
  const [search,   setSearch]   = useState('');
  const [selSvc,   setSelSvc]   = useState('All');
const [selLoc, setSelLoc] = useState('All Locations'); 
  const [showFilter, setShowFilter] = useState(false);

  /* Smart search: matches name, service, or location */
 const filtered = useMemo(() => {
  const q = search.trim().toLowerCase();
  return WORKERS.filter(w => {
    const matchSearch = !q ||
      w.name.toLowerCase().includes(q) ||
      w.service.toLowerCase().includes(q) ||
      w.location.toLowerCase().includes(q);
    const matchSvc = selSvc === 'All' || w.service === selSvc;
    const matchLoc = selLoc.toLowerCase() === 'all locations' || w.location.toLowerCase().includes(selLoc.toLowerCase());
    return matchSearch && matchSvc && matchLoc;
  });
}, [search, selSvc, selLoc]);

  const clearAll = () => { setSearch(''); setSelSvc('All'); setSelLoc('All Locations'); };
  const hasFilter = selSvc !== 'All' || selLoc !== 'All Locations' || search;

  return (
    <>
      <AppNavbar />
      <div className="aw2-page">

        {/* ── Header ── */}
        <div className="aw2-header">
          <button className="aw2-back" onClick={() => navigate(-1)}>
            <ArrowLeft size={20}/>
          </button>
          <h2 className="aw2-title">All Workers</h2>
          <button
            className={'aw2-filter-btn' + (showFilter ? ' aw2-filter-btn--active' : '')}
            onClick={() => setShowFilter(p => !p)}
          >
            <SlidersHorizontal size={18}/>
          </button>
        </div>

        {/* ── Search bar ── */}
        <div className="aw2-search-wrap">
          <div className="aw2-search">
            <Search size={15} className="aw2-search__icon"/>
            <input
              type="text"
              value={search}
              onChange={e => setSearch(e.target.value)}
              placeholder="Search workers by name..."
              className="aw2-search__input"
            />
            {search && (
              <button className="aw2-search__clear" onClick={() => setSearch('')}>
                <X size={14}/>
              </button>
            )}
          </div>
        </div>

        {/* ── Filter panel ── */}
        {showFilter && (
          <div className="aw2-filters">
            <div className="aw2-filter-group">
              <span className="aw2-filter-label">SERVICE TYPE</span>
              <div className="aw2-chips">
                {SERVICES.map(s => {
                  const Icon = SERVICE_ICONS[s];
                  return (
                    <button
                      key={s}
                      className={'aw2-chip' + (selSvc === s ? ' aw2-chip--active' : '')}
                      onClick={() => setSelSvc(s)}
                    >
                      {Icon && <Icon size={12}/>} {s}
                    </button>
                  );
                })}
              </div>
            </div>
            <div className="aw2-filter-group">
              <span className="aw2-filter-label">LOCATION</span>
              <div className="aw2-chips">
                {LOCATIONS.map(l => (
                  <button
                    key={l}
                    className={'aw2-chip' + (selLoc === l ? ' aw2-chip--active' : '')}
                    onClick={() => setSelLoc(l)}
                  >
                    {l !== 'All Locations' && <MapPin size={11}/>} {l}
                  </button>
                ))}
              </div>
            </div>
          </div>
        )}

        {/* ── Count ── */}
        <div className="aw2-count-row">
          <span className="aw2-count">{filtered.length} workers found</span>
          {hasFilter && (
            <button className="aw2-clear" onClick={clearAll}>Clear all</button>
          )}
        </div>

        {/* ── Worker cards ── */}
        <div className="aw2-list">
          {filtered.length === 0 ? (
            <div className="aw2-empty">
              <Search size={38}/>
              <p>No workers found</p>
            </div>
          ) : filtered.map((w, i) => {
            return (
              <div
                key={w.id}
                className="aw2-card"
                style={{ animationDelay: i * 0.06 + 's' }}
                onClick={() => navigate(`/book-workers` )}
              >
                {/* Profile Image */}
                <div className="aw2-card__avatar">
                  <img 
                    src={w.profileImage} 
                    alt={w.name}
                    className="aw2-card__avatar-img"
                  />
                  {w.verified && (
                    <div className="aw2-card__verified-badge">
                      <CheckCircle size={12} fill="white" />
                    </div>
                  )}
                </div>

                {/* Info */}
                <div className="aw2-card__info">
                  <div className="aw2-card__name-row">
                    <span className="aw2-card__name">{w.name}</span>
                    {w.verified && (
                      <span className="aw2-card__verified-text">Verified</span>
                    )}
                  </div>
                  <span className="aw2-card__service">{w.service}</span>
                  <div className="aw2-card__meta">
                    <Star size={12} fill="#f59e0b" color="#f59e0b"/>
                    <span>{w.rating}</span>
                    <span className="aw2-card__reviews">({w.reviews})</span>
                    <MapPin size={11} className="aw2-card__pin"/>
                    <span>{w.location}</span>
                  </div>
                </div>

                {/* Rate */}
                <div className="aw2-card__rate-wrap">
                  <span className="aw2-card__rate">{w.rate}</span>
                  <span className="aw2-card__per">/hour</span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default AllWorkers;